import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'spb-radio-slider',
  templateUrl: './radio-slider.component.html',
})
export class RadioSliderComponent implements OnInit {
  @HostBinding('class.spb-radio-slider') hostBaseClass = true;
  @Input() sliderSelectedValue = 3;
  @Input() sliderMinValue = 1;
  @Input() sliderMaxValue = 5;
  @Output() changeEvent = new EventEmitter();


  constructor() {
  }

  ngOnInit() {
  }

  onChange(event: any) {
    this.changeEvent.emit(event);
  }

}
